













import { Component, Prop, Vue } from 'vue-property-decorator'
import CustomExistingPortfolioV2 from '@company-common/model/kyc-form/existing-plans/CustomExistingPortfolioV2'
import { FormStructure } from '@master/model/structure/FormStructure'
import AppForm from '@core/components/AppForm.vue'
import AppDialog from '@core/components/AppDialog.vue'
import { UIService } from '@core/services/UIService'
import { inject } from 'inversify-props'
import { SharedVariable } from '@core/model/SharedVariable'

@Component({
  components: {
    AppDialog,
    AppForm
  }
})
export default class TheCurrentPlansDialog extends Vue {
  @Prop() readonly model: CustomExistingPortfolioV2
  @Prop() readonly structure: FormStructure<CustomExistingPortfolioV2>
  @Prop() readonly mode: 'edit' | 'create'

  @inject()
  private sharedVariable: SharedVariable

  uiService: UIService

  close () {
    this.$emit('close')
  }

  addPortfolio () {
    if (!this.model.policyName || this.model.policyName === '') {
      return this.uiService.alert.show({
        type: 'error',
        message: 'Please key in valid policy name.'
      })
    }
    this.$emit('add', this.model)
  }

  savePortfolio () {
    if (!this.model.policyName || this.model.policyName === '') {
      return this.uiService.alert.show({
        type: 'error',
        message: 'Please key in valid policy name.'
      })
    }
    this.$emit('save', this.model)
  }

  mounted () {
    this.uiService = this.sharedVariable.uiService
  }
}
